import { z } from 'zod';
import { actionDestinationSchema } from './actions.js';
// Enrichment DTOs (snake_case wire contract). Org-level settings are on/off
// capability toggles only — provider routing stays super-admin (see
// provider-config); customers never see provider names.
// Org-level enrichment capabilities — Settings → Enrichment.
export const enrichmentSettingsSchema = z.object({
    company: z.object({ enabled: z.boolean() }),
    // Whether Data Legion is configured (env) — surfaced for provider-availability
    // hints in the UI.
    datalegion_available: z.boolean().optional(),
});
// Per-project auto-enrich rules (Automations → Enrichment).
export const projectEnrichmentSettingsSchema = z.object({
    project_id: z.string(),
    organization_id: z.string(),
    auto_enrich_company: z.boolean(),
    auto_enrich_person: z.boolean(),
    // "Notify on new identification/enrichment" destinations (notify/webhook).
    notify_destinations: z.array(actionDestinationSchema).default([]),
});
// Result of an on-demand enrich (company or person). `reason` is set when
// `ok` is false (e.g. 'not_found', 'disabled', 'rate_limited').
export const enrichResultSchema = z.object({
    ok: z.boolean(),
    status: z.string().optional(),
    reason: z.string().optional(),
});
//# sourceMappingURL=enrichment.js.map